/**
 * useEnsayoVoz — el "Así suena" del wizard, calculado por el generador REAL del backend.
 *
 * Vivía dentro de VozForm (paso "Tu voz"), pero el ejemplo depende de TODO el contexto —el tono
 * y también la oferta (el "{oferta}" que el mensaje promete)—, así que tiene sentido en más de
 * un paso: mientras configurás la oferta querés ver cómo cambia el mensaje. Subirlo a un hook
 * deja que el wizard lo muestre pegado abajo, acompañando la configuración, con UN solo fetch
 * en vez de que cada paso pida el suyo.
 *
 * El ensayo lo calcula SIEMPRE el backend (`POST /activa/voz/ensayo`) con el mismo generador que
 * arma los mensajes que se mandan: no puede divergir de lo que recibe el cliente. Si la request
 * falla, NO se inventa un ejemplo escrito a mano — se deja el último bueno y ya.
 */

import { useEffect, useRef, useState } from "react";
import type { ContextReal } from "../types.real";
import { activaApi } from "../api";

export interface EnsayoVoz {
  mensaje: string;
  desglose: { parte: string; texto: string; lo_decide: string }[];
  prohibidasEncontradas: string[];
  caracteres: number;
  nombreDeEjemplo: string;
}

export function useEnsayoVoz(marca: string | undefined, contexto: ContextReal): { ensayo: EnsayoVoz | null; cargando: boolean } {
  const [ensayo, setEnsayo] = useState<EnsayoVoz | null>(null);
  const [cargando, setCargando] = useState(false);
  const primera = useRef(true);

  /**
   * Con debounce: mover un slider o tipear en el CTA no puede disparar una request por tecla.
   * La primera vez sale sin espera (para que el ejemplo esté al abrir el paso); las siguientes,
   * a los 350ms de que el usuario deje de tocar.
   */
  useEffect(() => {
    let vivo = true;
    setCargando(true);
    const t = setTimeout(() => {
      activaApi
        .ensayarVoz(marca || "", contexto)
        .then((r: any) => { if (vivo && r?.success !== false) setEnsayo(r.data); })
        .catch(() => { /* si el ensayo no sale, no se inventa un ejemplo: se deja el último bueno */ })
        .finally(() => { if (vivo) setCargando(false); });
    }, primera.current ? 0 : 350);
    primera.current = false;
    return () => { vivo = false; clearTimeout(t); };
  }, [marca, contexto]);

  return { ensayo, cargando };
}
